export enum StudentType {
  NORMAL = 'normal',
  INSTITUTE = 'institute'
}

export interface StudentTypeInfo {
  type: StudentType;
  isInstituteStudent: boolean;
  hasInstituteSubscription: boolean;
  instituteId: number | null;
  instituteLogo: string | null;
}

export const getStudentType = (userState: any): StudentTypeInfo => {
  const isInstituteStudent = userState.InstituteId !== null;
  const hasInstituteSubscription = userState.Institute_sub_PlanName !== null;
  
  return {
    type: isInstituteStudent ? StudentType.INSTITUTE : StudentType.NORMAL,
    isInstituteStudent,
    hasInstituteSubscription,
    instituteId: userState.InstituteId,
    instituteLogo: userState.Institutelogoimageurl
  };
};

export const isInstituteStudent = (userState: any): boolean => {
  return userState.InstituteId !== null;
};